import { render, staticRenderFns } from "./CanvasSeatMap.vue?vue&type=template&id=5a06d2b1&scoped=true&"
import script from "./CanvasSeatMap.vue?vue&type=script&lang=ts&"
export * from "./CanvasSeatMap.vue?vue&type=script&lang=ts&"
import style0 from "./CanvasSeatMap.vue?vue&type=style&index=0&id=5a06d2b1&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a06d2b1",
  null
  
)

export default component.exports